// Rótulos e cores das vendas/assinaturas, usados na página Vendas e na lista de usuários

export const PROVIDERS = {
  cakto: { label: 'Cakto', dot: 'bg-[#2a78d6] dark:bg-[#3987e5]' },
  hotmart: { label: 'Hotmart', dot: 'bg-[#eb6834] dark:bg-[#d95926]' },
};

export const PLANS = { mensal: 'Mensal', trimestral: 'Trimestral', anual: 'Anual', 'mensal-alunos': 'Mensal (alunos)' };
export const planLabel = (plan) => PLANS[plan] || plan || '—';

// Situação da conta cruzando o Controlly com o gateway (calculada no backend)
export const SITUATIONS = {
  expired_active: { label: 'Venceu e segue ativo', tone: 'red', hint: 'O pagamento acabou e a Nath continua liberada' },
  paid_inactive: { label: 'Pagou e está inativo', tone: 'amber', hint: 'Ainda tem período pago, mas a conta está inativa' },
  expiring: { label: 'Vence em até 7 dias', tone: 'amber', hint: 'Ativo, com o pagamento acabando nos próximos 7 dias' },
  active_no_payment: { label: 'Ativo sem pagamento', tone: 'blue', hint: 'Ativo sem assinatura paga na Cakto nem na Hotmart (parceiros, liberados na mão)' },
  no_account: { label: 'Pagou sem conta', tone: 'blue', hint: 'Tem pagamento em dia, mas nenhuma conta com o mesmo e-mail ou telefone' },
  ok: { label: 'Em dia', tone: 'green', hint: 'Ativo e com pagamento em dia' },
  inactive: { label: 'Inativo', tone: 'neutral', hint: 'Sem acesso e sem pagamento' },
};

export const GATEWAY_STATUS = {
  active: ['Ativa', 'green'], overdue: ['Atrasada', 'amber'], canceled: ['Cancelada', 'neutral'], inactive: ['Inativa', 'neutral'],
};

export const SALE_STATUS = {
  paid: ['Paga', 'green'], refunded: ['Reembolsada', 'red'], chargeback: ['Chargeback', 'red'], canceled: ['Cancelada', 'neutral'],
  refused: ['Recusada', 'neutral'], pending: ['Aguardando', 'amber'], overdue: ['Atrasada', 'amber'], expired: ['Expirada', 'neutral'],
};

export const money = (value) => (value || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

export const shortDate = (value) => value
  ? new Date(value).toLocaleDateString('pt-BR', { day: '2-digit', month: 'short', year: '2-digit', timeZone: 'America/Sao_Paulo' })
  : '—';

const DAY = 24 * 60 * 60 * 1000;

// "vence em 5 dias", "venceu há 12 dias", "vence hoje"
export const relativeDue = (value) => {
  if (!value) return null;
  const days = Math.round((new Date(value).getTime() - Date.now()) / DAY);
  if (days === 0) return 'vence hoje';
  if (days > 0) return `vence em ${days} ${days === 1 ? 'dia' : 'dias'}`;
  return `venceu há ${-days} ${days === -1 ? 'dia' : 'dias'}`;
};
